<template>
    <SOSlotBase
        :bg-white="true"
    >
        <template v-slot:title-bar>
            <SOTitleBar
                :page-title="'Pilih template'"
                :type="'back'"
                @back="back"
            />
        </template>

        <template v-slot:empty-state>
            <SOEmptyState
                v-if="false"
                :message="'Belum ada template'"
                :sub-message="'Anda belum memiliki template pesan. Klik tombol dibawah untuk membuat template.'"
                :btn-action="'+ Buat template baru...'"
                @action="() => {}"
            />
        </template>

        <template v-slot:skeleton>
            <div class="p-x-20 p-y-12" v-if="isFetching">
                <SOCardTransaksiSkeleton/>
            </div>
        </template>

        <template v-slot:content>
            <div class="p-x-20 p-y-16">
                <div class="f-semi f-14 f-c-blue p-d-12"
                     @click="goCreateTemplate()">
                    + Buat template baru...
                </div>

                <SOInputSearch
                    class="p-d-12"
                    :id="'filter-search'"
                    :autocomplete="'off'"
                    :delay-time="2000"
                    :do-searching="setSearchKey"
                />

                <CardTemplateBlast :data-list="listTemplate" @selectedIdTemplate="(v) => { selectedIdtemplate = v }"/>
            </div>

            <div
                class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white shadow"
                style="position: fixed; bottom: 64px;">
                <div class="p-x-20 p-y-8 w-100">
                    <div class="row m-0">
                        <div class="col-6 p-0">
                            <div class="f-regular f-12 f-c-midgrey">Terpilih</div>
                            <div class="f-regular f-14 f-c-black">
                                {{ selectedIdtemplate.length }} Template
                            </div>
                        </div>
                        <div class="col-6 p-0" @click="pilihTemplate">
                            <button class="btn btn-primary btn-block m-0">Pilih template</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </SOSlotBase>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {moduleName} from "./../store/state";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOCardTransaksiSkeleton from "@/so-components/modules/transaksi/reguler/SOCardTransaksiSkeleton";
import SOInputSearch from "@/so-components/global/input/SOInputSearch";
import CardTemplateBlast from "@/modules/wa-blast/components/CardTemplateBlast";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "WABlastTemplateList",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOEmptyState,
        SOCardTransaksiSkeleton,
        SOInputSearch,
        CardTemplateBlast,
        SOButton,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            endItemofPage: "endItemofPage",
            listTemplate: "listTemplate",
            totalTemplate: "totalTemplate",
            payloadCreateBlast: "payloadCreateBlast",

            search: "search",
            searchLoading: "searchLoading",
            isSearch: "isSearch",
            blastType: "blastType",
        }),
        listNull() {
            return this.totalTemplate === 0 && !this.isFetching
        },
        listNullNoSearch() {
            return this.listNull && !this.isSearch
        },
        listNullSearch() {
            return this.listNull && this.isSearch && !this.searchLoading && this.search.length > 2
        }
    },
    data() {
        return {
            selectedIdtemplate: [],
            jenis: null
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path.split("/")[1] !== "wa-blast" && from.path.split("/")[1] !== "template") {
                vm.resetListTemplate()
                vm.resetPaginationTemplate()
            }
        })
    },
    mounted() {
        this.init();
        // this.scrollTo();
    },
    methods: {
        ...mapActions({
            fetchListTemplate: `${moduleName}/fetchListTemplate`,

            setEndItemofPage: `${moduleName}/setEndItemofPage`,
            resetPaginationTemplate: `${moduleName}/resetPaginationTemplate`,
            resetListTemplate: `${moduleName}/resetListTemplate`,
            openSearchTemplate: `${moduleName}/openSearchTemplate`,
            closeSearchTemplate: `${moduleName}/closeSearchTemplate`,
            setSearchTemplate: `${moduleName}/setSearchTemplate`,
            loadingSearchTemplate: `${moduleName}/loadingSearchTemplate`,
            doSearchTemplate: `${moduleName}/doSearchTemplate`,
            setPayloadCreateBlast: `${moduleName}/setPayloadCreateBlast`,
        }),
        init() {
            this.getJenis();
            if (this.blastType != this.jenis) {
                this.$store.commit(`${moduleName}/setBlastType`, this.jenis);
                this.resetListTemplate()
            }
            if (this.listTemplate.length === 0) {
                this.resetPaginationTemplate();
                this.fetchListTemplate({jenis: this.jenis});
            }
        },
        scrollTo() {
            let el = document.getElementById(`card-${this.endItemofPage.id}`);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView();
                    document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
                }, 100);
            }
        },
        back() {
            this.$router.back()
            setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight);
            }, 1000)
        },
        setSearchKey(key) {
            this.resetListTemplate()
            this.resetPaginationTemplate();
            this.fetchListTemplate({key: key});
            this.setSearchTemplate(key)
        },
        pilihTemplate() {
            let selectedIdtemplateInt = []
            this.selectedIdtemplate.forEach(v => {
                selectedIdtemplateInt = selectedIdtemplateInt.concat(parseInt(v))
            })

            this.payloadCreateBlast.idtemplate = selectedIdtemplateInt
            this.payloadCreateBlast.namaTemplate = []
            this.selectedIdtemplate.forEach(id => {
                this.payloadCreateBlast.namaTemplate = this.payloadCreateBlast.namaTemplate.concat(this.listTemplate.filter(v => v.id == id)[0].nama)
            })
            this.setPayloadCreateBlast(this.payloadCreateBlast)
            this.back()
        },
        getJenis() {
            this.jenis = this.$route.query.jenis || null;
        },
        goCreateTemplate() {
            this.$router.push({name: 'wa_blast.template-pesan.create'})
        }
    },
    watch: {
        isFetching: {
            handler: function (val) {
                if (this.listNull && this.blastType != null) {
                    this.goCreateTemplate()
                } 
            },
            deep: true
        },
    }
}
</script>